import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const getDuration = ms => ({
  days: Math.floor(ms / 86400000),
  hours: Math.floor(ms / 3600000) % 24,
  minutes: Math.floor(ms / 60000) % 60,
  seconds: Math.floor(ms / 1000) % 60,
});

const Elapsed = ({ startedAt, updateInterval = 1000 }) => {
  const locale = useSelector(state => state.i18n.locale);
  const [elapsed, setElapsed] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      const duration = getDuration(Date.now() - new Date(startedAt).getTime());
      setElapsed(new Intl.DurationFormat(locale, { style: 'narrow' }).format(duration));
    }, updateInterval);
    return () => clearInterval(interval);
  });

  return elapsed;
};

export default Elapsed;
